export default class ChartBar {
  public readonly id: number;
  public readonly label: string;
  public readonly color: string;
  public readonly start: number;
  public readonly span: number;
  public readonly days: string[];

  public constructor(params: Partial<ChartBar>) {
    if (params.span && params.span < 0) throw new Error("Invalid value");
    this.id = params.id || 0;
    this.label = params.label || "";
    this.color = params.color || "";
    this.start = params.start || 0;
    this.span = params.span || 0;
    this.days = params.days || [];
  }
}
